import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteCenterExceptionalExpense(id: number, exceptionalExpenseId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.centers.deleteCenterExceptionalExpense.url, { id, exceptionalExpenseId })
    )
    .delete()
}
